import React, { Component } from 'react';
import { withRouter } from 'src/containers/withRouter/withRouter';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Tooltip, LayoutContentEmpty, parseQuery, Popover, Spin } from '@jjj/components';
import TopbarDropdownWrapper from './topbarDropdown.style';
import actions from '../../redux/app/actions';
import notificationsCenterActions from '../notificationsCenter/actions';
import { getLink, getTitle, getBody } from '../notificationsCenter/component/notificationComponent';
import { NotificationWrapper, ButtonWrapper, SpinWrapper, NotificationBadgeWrapper } from './topbarNotification.style';
import { getNotificationsUnreadCountByCountryId } from '../../helpers/notifications';
import { t } from '../../i18n';
import { NotificationBadge } from './notificationBadge/notificationBadge';

class TopbarNotification extends Component {
  constructor(props) {
    super(props);
    this.handleVisibleChange = this.handleVisibleChange.bind(this);
    this.hide = this.hide.bind(this);
  }

  state = { visible: false };

  UNSAFE_componentWillUpdate(nextProps, nextState) {
    const { loadTopNavNotificationsRequest } = this.props;

    if (this.state.visible !== nextState.visible && nextState.visible) {
      const { auth, notificationsUnreadCount, data } = nextProps;
      const { selectedCountry } = auth;
      const [{ new_count }] = getNotificationsUnreadCountByCountryId(notificationsUnreadCount, selectedCountry.id);

      if (data.notifications.length !== new_count) {
        loadTopNavNotificationsRequest();
      }
    }
  }

  handleVisibleChange() {
    const { visible } = this.state;
    this.setState({ visible: !visible });
  }

  handleMarkAsRead = (id, shouldRefreshNotificationsCenterList) => {
    const { history } = this.props;
    const { search = '' } = this.props.history.location;
    const query = parseQuery(search);
    const updateNotificationCenter =
      shouldRefreshNotificationsCenterList && history.location.pathname.includes('notifications');

    this.props.notificationMarkAsRead({ id, shouldReloadTopNav: true, query: updateNotificationCenter ? query : null });
  };

  handleLinkClick = (event, read_at, id, url) => {
    if (!url && !event.target.getAttribute('href')) {
      event.preventDefault();
    }

    if (!read_at && event.target.getAttribute('href')) {
      this.handleMarkAsRead(id);
    }

    if (event.target.getAttribute('href')) {
      this.handleHide();
    }
  };

  handleHide = () => {
    this.hide();
  };

  hide() {
    this.setState({ visible: false });
  }

  render() {
    const { visible } = this.state;
    const { auth, notificationsUnreadCount, data } = this.props;
    const { isTopNavNotificationsLoading, notifications } = data;
    const { selectedCountry } = auth;
    const [{ new_count }] = getNotificationsUnreadCountByCountryId(notificationsUnreadCount, selectedCountry?.id);

    const content = (
      <TopbarDropdownWrapper className="topbarNotification">
        <div className="isoDropdownHeader">
          <h3>{t('dash.topbar.notifications_header')}</h3>
        </div>
        {isTopNavNotificationsLoading && (
          <SpinWrapper>
            <Spin />
          </SpinWrapper>
        )}
        <div className="isoDropdownBody">
          {notifications &&
            notifications.map(notification => {
              const url = getLink(notification, auth.role);
              const title = getTitle(notification);
              const body = getBody(notification, auth.role);

              return (
                <NotificationWrapper key={notification.id}>
                  <Link
                    key={notification.id}
                    to={url}
                    disabled={!url}
                    className={notification.read_at ? 'read' : 'unread'}
                    onClick={event => this.handleLinkClick(event, notification.read_at, notification.id, url)}
                    data-cy="topbar-notification-read-unread-link"
                  >
                    <div className="isoDropdownListItem">
                      {title && (
                        <div className="isoListHead">
                          <h5>{title}</h5>
                        </div>
                      )}
                      {body && <div className="isoListItem">{body}</div>}
                    </div>
                  </Link>
                  <ButtonWrapper>
                    <div className="notification-icon-wrapper">
                      {notification.read_at && <div className="circle" />}
                      {!notification.read_at && (
                        <Tooltip placement="bottom" title="Mark as Read" popupAlign={{ offset: [-4, 0] }}>
                          <button
                            type="button"
                            onClick={() => !notification.read_at && this.handleMarkAsRead(notification.id, true)}
                            className="circle-button"
                            data-cy="topbar-notification-mark_as_read_button"
                          >
                            <div className="unread circle " />
                          </button>
                        </Tooltip>
                      )}
                    </div>
                  </ButtonWrapper>
                </NotificationWrapper>
              );
            })}
          {notifications && notifications.length === 0 && !isTopNavNotificationsLoading && (
            <LayoutContentEmpty size="small" text={t('dash.topbar.no_notifications_to_display')} />
          )}
        </div>
        <Link
          className="isoViewAllBtn"
          to="/notifications?tab=active"
          onClick={this.handleHide}
          data-cy="topbar-notification-view_all-link"
        >
          {t('dash.topbar.view_all_link')}
        </Link>
      </TopbarDropdownWrapper>
    );

    return (
      <Popover
        content={content}
        open={visible}
        trigger="click"
        onOpenChange={this.handleVisibleChange}
        placement="bottomLeft"
        popupAlign={{ offset: [3, 5] }}
        classNames={{ root: 'topbar-notification-popover' }}
      >
        <NotificationBadgeWrapper className="isoIconWrapper">
          <i className="fas fa-bell" />
          <NotificationBadge count={new_count} />
        </NotificationBadgeWrapper>
      </Popover>
    );
  }
}

export default connect(
  state => ({
    ...state.App,
    data: state.NotificationsCenter,
    auth: state.Auth,
  }),
  dispatch => ({
    notificationMarkAsRead: /* istanbul ignore next */ data => dispatch(actions.notificationMarkAsRead(data)),
    loadTopNavNotificationsRequest: /* istanbul ignore next */ () =>
      dispatch(notificationsCenterActions.loadTopNavNotificationsRequest()),
  }),
)(withRouter(TopbarNotification));
